import { addClass, on, removeClass, select, selectAll } from 'helpers/dom'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'

const selectors = {
  HEADER_ID: 'site-header',
  BUTTON_SELECTOR: '.js-scroll-button',
  DESCRIPTION_SELECTOR: '.js-description',
  READ_MORE_BUTTON_SELECTOR: '.read-more-button',
  LINE_CAMP_CLASS: 'line-clamp-4',
  HIDDEN_CLASS: 'hidden',
  BLOCK_CLASS: 'block'
}

class ScrollButton extends HTMLElement {
  constructor () {
    super()
    this.scrollButton = selectAll(selectors.BUTTON_SELECTOR, this)
    this.description = select(selectors.DESCRIPTION_SELECTOR)

    this.init()
  }

  init() {
    this.handleContent()
    this.isScroll()
  }

  isScroll() {
    this.scrollButton.forEach(button => {
      button && on(
        'click', (e) => {
          e.preventDefault()

          const buttonReadMore = select(selectors.READ_MORE_BUTTON_SELECTOR)
          const targetId = button.getAttribute('data-href').replace(/#/g, '')
          const targetElement = document.getElementById(targetId)
          const headerHeight = document.getElementById('site-header').offsetHeight

          if (targetElement) {
            const targetPosition = targetElement.offsetTop - headerHeight

            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            })
          }

          if (buttonReadMore) {
            buttonReadMore.click()
          }
        },
        button
      )
    })
  }

  handleContent() {
    const lineHeight = parseFloat(getComputedStyle(this.description).lineHeight)
    const numberOfLines = this.description.clientHeight / lineHeight

    if (numberOfLines > 4) {
      addClass(selectors.LINE_CAMP_CLASS, this.description)
      addClass(selectors.BLOCK_CLASS, this.scrollButton)
      removeClass(selectors.HIDDEN_CLASS, this.scrollButton)
    }
  }
}

if (!customElements.get('button-scroll')) {
  customElements.define('button-scroll', ScrollButton)
}
